var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showDate
    ? _c("div", { staticClass: "error" }, [
        _vm._v("\n    *" + _vm._s(_vm.job) + " will be automatically\n    "),
        _c("b", [_vm._v("Complete")]),
        _vm._v("\n    if assigned to a team member.\n"),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }